import TNTControlBase from '../../util/TNTControlBase';

class UserPermissionReportController extends TNTControlBase {
  /*@ngInject*/
  constructor($state) {
    super();
    this.acl = {}
    this.hasACL = {}
    this.id = 'user_permission_report'
    this.$state = $state
    this.hasACL = {}
  }
  $onInit() {
    super.$onInit()
    for (let key in this.acl['tnt_control_'+this.id]) {
      this.hasACL[this.acl['tnt_control_'+this.id][key]] = true;
    }
  }
}

export default UserPermissionReportController;


// WEBPACK FOOTER //
// ./client/app/components/tnt_control/component/user_permission_report/user_permission_report.controller.js